import {
	Component,
	OnInit,
	ComponentFactoryResolver,
	OnDestroy,
	ViewChild,
	ElementRef, OnChanges, SimpleChanges, Input
} from '@angular/core';
// Services
import { SubContentService, BroadcastService } from '@cv-invision/core';
import { ViewsService } from '../../../services/views.service';
// Models
import { LayoutPages } from '../../models/layout-pages.model';
// Components

@Component({
	selector: 'cv-review-layout',
	templateUrl: './layout-drawer.component.html',
	styleUrls: ['./layout-drawer.component.scss']
})
export class LayoutDrawerComponent implements OnInit, OnDestroy, OnChanges {
	@Input() section;
	@Input() index?;
	@Input() isEditing = false;
	// @Input() schema;
	// @Input() document;
	// @Input() order;

	@ViewChild('contentRevised', { static: true }) contentRevised: ElementRef<any>;
	sections: any;
	selectedRules: any;
	schemaName: any;
	isLayoutLoaded = false;

	get order(): any {
		return this.viewsServices.order;
	}
	get document(): any {
		return this.viewsServices.document;
	}
	get schema(): any {
		return this.viewsServices.schema;
	}
	get photos(): any {
		return this.viewsServices.photos;
	}

	constructor(
		private subContentService: SubContentService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcastService: BroadcastService,
		private viewsServices: ViewsService
	) {
	}

	/**
	 * Load layout only once, once we know the schema of the order.
	 *
	 */
	async loadLayout(): Promise<void> {
		this.broadcastService.broadcast({
			name: 'historicalValueEvent',
			event: {
				isOpen: false,
				data: [],
				pos: {}
			}
		});
		this.schemaName = this.order.schema;
		this.isLayoutLoaded = true;

		const schemasPages = new LayoutPages();
		const layoutCreator = schemasPages.pages[this.schemaName][this.section].layout;
		if (layoutCreator) {
			this.sections = new layoutCreator().sections;
			this.selectedRules = schemasPages.pages[this.schemaName][this.section].rules;
		}
	}

	ngOnInit(): void {
		this.loadLayout();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			('section' in changes && !changes.section.firstChange)
			|| ('index' in changes && !changes.index.firstChange)
		) {
			this.loadLayout();
		}

		if ('isEditing' in changes && changes.isEditing.currentValue !== this.viewsServices.isEditing) {
			this.viewsServices.setEditing(changes.isEditing.currentValue);
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		this.schemaName = null;
	}
}
